import { useStore } from '../../store/useStore';

export const ClassSelector = ({ inline }: { inline?: boolean }) => {
    const { playerClass, setPlayerClass, setTheme } = useStore();

    const classes = ['warrior', 'archer', 'wizard'] as const;

    const containerStyle: React.CSSProperties = inline ? {
        display: 'flex',
        gap: '12px',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'auto'
    } : {
        position: 'absolute',
        top: '280px', // Under instructions
        left: '20px',
        bottom: 'auto',
        display: 'flex',
        flexDirection: 'column', // Vertical
        gap: '10px',
        background: 'rgba(0,0,0,0.5)',
        padding: '10px',
        borderRadius: '12px',
        pointerEvents: 'auto'
    };

    return (
        <div style={containerStyle}>
            {classes.map((c) => (
                <button
                    key={c}
                    onClick={() => { setPlayerClass(c); setTheme('medieval'); }}
                    style={{
                        background: playerClass === c ? '#ffd700' : '#444',
                        color: playerClass === c ? '#000' : '#fff',
                        border: '1px solid #fff',
                        borderRadius: '8px',
                        padding: '10px 14px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        textTransform: 'capitalize',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        justifyContent: 'center',
                        minWidth: inline ? 110 : 120
                    }}
                >
                    <span style={{ fontSize: '1.2em' }}>
                        {c === 'archer' ? '🏹' : c === 'wizard' ? '✨' : '⚔️'}
                    </span>
                    <span>{c}</span>
                </button>
            ))}
        </div>
    );
};
